(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfClickAndDisable', function() {
    return {
      restrict: 'A',
      scope: {
        mfClickAndDisable: '&',
        alwaysReenable: '='
      },
      link: function(scope, ele, attrs) {
        return ele.bind('click', (function(_this) {
          return function() {
            var promise;
            ele.prop('disabled', true);

            /*
            NOTE: To take full advantage of this directive
            call any operation that causes an ajax report last
            
            e.g. mf-click-and-disable="scope_var++; save();"
             */
            promise = scope.mfClickAndDisable();
            return promise != null ? typeof promise.then === "function" ? promise.then(function(result) {
              var ref, ref1;
              if (scope.alwaysReenable || (result == null) || (result != null ? (ref = result.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'error') {
                return ele.prop('disabled', false);
              }
            }, function() {
              return ele.prop('disabled', false);
            }) : void 0 : void 0;
          };
        })(this));
      }
    };
  });

}).call(this);
